import React from 'react';
export function Footer() {
  return <footer className="py-12 px-4 bg-navy-dark text-cream-bg" data-id="element-147">
      <div className="max-w-6xl mx-auto" data-id="element-148">
        <div className="text-center mb-8" data-id="element-149">
          <h3 className="font-serif text-2xl font-bold mb-4" data-id="element-150">
            📚 MÁS ALLÁ DE LA VOLUNTAD™
          </h3>
          <p className="text-cream-bg/80 max-w-3xl mx-auto leading-relaxed" data-id="element-151">
            El sistema de acompañamiento N°1 para orientadores en adicciones
            conductuales en Argentina. Porque acompañar bien no debería depender
            solo de la intuición ni costar el desgaste de quien acompaña.
          </p>
        </div>

        <div className="text-center mb-8 text-cream-bg/70" data-id="element-152">
          <p data-id="element-153">
            contacto@ideahubdigital.online • @ideahubdigital •
            ideahubdigital.online
          </p>
        </div>

        <div className="text-center text-sm text-cream-bg/60" data-id="element-154">
          <p data-id="element-155">
            © ideahubdigital.online™ 2025 — Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>;
}